import React, { useContext } from 'react';

import { AsaphButton } from '@/components/shared/Button';

import { CopilotContext, CopilotState } from '../CopilotPage';
import styles from '../CopilotPage.module.scss';

const CopilotUserNotFound: React.FC = () => {
	const { authData, setToken, setState, token } = useContext(CopilotContext);

	return (
		<div className={styles['flex-between']}>
			<div className={styles['blurb']}>
				No account found
				{authData?.email ? (
					<>
						<span>&nbsp;for&nbsp;</span>
						<strong style={{ color: 'black' }}>
							{authData.email}
						</strong>
					</>
				) : null}
				.<br />
				<br />
				Would you like to connect to an existing Asaph account or create
				a new one?
			</div>
			<div className={styles['accept-row']}>
				<AsaphButton
					label="Connect Account"
					onClick={() => setState(CopilotState.LinkUser)}
					color="grey"
				/>
				<AsaphButton
					label="Create account"
					onClick={() => setState(CopilotState.CreateUser)}
					color="blue"
				/>
			</div>
		</div>
	);
};

export default CopilotUserNotFound;
